import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'configs';
import { useSharedLegalApi } from 'services/useSharedLegalApi';
import { hasValue } from 'utils';

export const useGetLegalTextsByIdentifier = (
  legalTextIdentifiers: string[] = []
) => {
  const { getLegalTextsByIdentifier } = useSharedLegalApi();

  return useQuery({
    queryKey: [queryKeys.getLegalTextsByIdentifier, { legalTextIdentifiers }],
    queryFn: () => getLegalTextsByIdentifier({ legalTextIdentifiers }),
    enabled: hasValue(legalTextIdentifiers)
  });
};
